import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    class: "live2d-conrainer",
    id: "live2d-conrainer"
};
var _hoisted_2 = { class: "live2d-talk-content" };
import { onMounted, ref, onBeforeUnmount } from "vue";
import { useStore } from "@/store";
import * as PIXI from "pixi.js"; // 必须使用6版本的 pixi.js，否则新版对于 pixi-live2d-display 有些api被弃用（推荐 6.5.10 或 6.4.2）
// @ts-ignore // 忽略 pixi-live2d-display 的类型定义，因为提供的类型文件在当前 ts.config.json 的 moduleResolution 选项下无法解析
import { Live2DModel } from "pixi-live2d-display/cubism4";
import api from "@/utils/api";
import tools from "@/utils/tools";
var modelIndexLocalStorageKey = "live2d-character-index";
var settingsGroupSelector = ".live2d-settings-group";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Live2D',
    setup: function (__props) {
        var _this = this;
        var store = useStore();
        var isLoaded = ref(false);
        var isCharacterBeingHovered = ref(false), isLive2DCanvasHovered = ref(false);
        var isShowLive2DMessage = ref(false);
        var live2DMessage = ref("");
        window.PIXI = PIXI;
        var app = null;
        var model = null;
        var isFirstLoad = window.localStorage.getItem(modelIndexLocalStorageKey) === null;
        var live2DCanvas = null; // live2d canvas 元素
        var standbyOpacity = window.localStorage.getItem("live2d-standbyOpacity") || "0.5"; // 待机透明度
        var isForceStandby = false; // 是否处于强制待机状态
        var live2DComponent = null; // live2d 组件元素 live2DComponent = document.querySelector(".live2d-conrainer")
        var live2DMessageDisapearTimeout = null; // 对话框消失的定时器
        var dragMoveX = undefined, dragMoveY = undefined;
        var chats = null; // 对话内容，根据选择角色加载
        var live2dJSONList = null; // 角色与其 live2d 资源列表
        var currentModelIndex = parseInt(window.localStorage.getItem(modelIndexLocalStorageKey) || "0"); // 当前模型索引
        var live2dResourceURL = "";
        function loadLive2D() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!live2dJSONList || live2dJSONList.length === 0) {
                                throw new Error("live2dJSONList 角色列表未加载");
                            }
                            if (currentModelIndex >= live2dJSONList.length) {
                                window.localStorage.setItem(modelIndexLocalStorageKey, "0");
                                currentModelIndex = 0;
                            }
                            live2dResourceURL = live2dJSONList[currentModelIndex].path;
                            console.log("加载 live2d 角色：", live2dResourceURL);
                            live2DCanvas = document.getElementById("live2d");
                            app = new PIXI.Application({
                                view: live2DCanvas,
                                autoStart: true,
                                backgroundAlpha: 0,
                                resizeTo: live2DCanvas,
                            });
                            return [4 /*yield*/, Live2DModel.from(live2dResourceURL)];
                        case 1:
                            model = _c.sent();
                            app.stage.addChild(model);
                            // laffey Ⅱ set
                            model.x = -25;
                            model.y = -50;
                            model.scale.set(live2dJSONList[currentModelIndex].scale);
                            console.log("live2d model width height:", model.width, model.height);
                            (_a = document
                                .getElementById("live2d-conrainer")) === null || _a === void 0 ? void 0 : _a.style.setProperty("width", "".concat(model.width, "px"));
                            (_b = document
                                .getElementById("live2d-conrainer")) === null || _b === void 0 ? void 0 : _b.style.setProperty("height", "".concat(model.height, "px"));
                            // model.expression(0).then((result) => {
                            //   console.log("Expression loaded", result);
                            // });
                            // 对话文件，需要将其放在与 xxx.model3.json 同级目录下
                            api.requestBase
                                .get(
                            // fetch(
                            // 将最后一段替换为 chats.json
                            live2dResourceURL.replace(/[^\/]+(?=\/?$)/, "chats.json"))
                                .then(function (resp) {
                                // return resp.json();
                                return resp.data;
                            })
                                .then(function (data) {
                                chats = data;
                            })
                                .catch(function (err) {
                                console.error("加载 live2d 对话内容失败", err);
                            });
                            updateSettingsGroupPosition();
                            isLoaded.value = true;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function destroyLive2D(isDeepDestroy) {
            if (isDeepDestroy === void 0) { isDeepDestroy = false; }
            if (!app)
                throw new Error("live2d app 异常");
            isLoaded.value = false;
            if (isDeepDestroy) {
                app.ticker.stop();
                app === null || app === void 0 ? void 0 : app.destroy(true); // true 代表销毁视图 canvas
                model === null || model === void 0 ? void 0 : model.destroy();
                return;
            }
            app.ticker.stop();
            // app?.destroy(true); // true 代表销毁视图 canvas
            if (model) {
                app.stage.removeChild(model); // 我不删了还不行吗
            }
            model === null || model === void 0 ? void 0 : model.destroy();
        }
        function switchLive2DCharacter() {
            destroyLive2D();
            loadLive2D();
        }
        var pixels = new Uint8Array(4); // 单次读取 live2d canvas 像素信息后的存储数组
        function setLive2DCanvasPixelColorToArray(x, y) {
            if (!app || !live2DCanvas)
                throw new Error("live2d \u5F02\u5E38:".concat(app ? "app" : "live2DCanvas", "\u4E3A null"));
            app.renderer.render(app.stage);
            var WebGL2Ctx = live2DCanvas.getContext("webgl2");
            if (!WebGL2Ctx)
                throw new Error("WebGL2Ctx 为空");
            WebGL2Ctx.readPixels(x, y, 1, 1, WebGL2Ctx.RGBA, // 格式
            WebGL2Ctx.UNSIGNED_BYTE, // 数据类型
            pixels // 存储数据的数组
            );
            return pixels;
        }
        function checkIsPositionOnLive2D(clientX, clientY) {
            if (!live2DCanvas)
                throw new Error("live2DCanvas 为空");
            var rect = live2DCanvas.getBoundingClientRect();
            if (!(clientX >= rect.left &&
                clientX <= rect.right &&
                clientY >= rect.top &&
                clientY <= rect.bottom)) {
                return false;
            }
            var x = clientX - rect.left;
            var y = clientY - rect.top;
            // 翻转 Y 坐标（WebGL 原点在左下角，鼠标坐标原点在左上角）
            var flippedY = rect.height - y;
            setLive2DCanvasPixelColorToArray(x, flippedY);
            return pixels[3] !== 0;
        }
        function stopForceStandby() {
            if (isForceStandby) {
                isForceStandby = false;
                isCharacterBeingHovered.value = true;
                if (chats)
                    setLive2DTalkContent(chats["endForceStandby"]);
                window.live2dStatus = "loaded";
                window.localStorage.setItem("live2d-isForceStandby", "false");
            }
        }
        function getLive2dStandbyOpacity() {
            return standbyOpacity;
        }
        function setLive2dStandbyOpacity(opacity) {
            if (!opacity)
                return;
            standbyOpacity = opacity || "0.5";
            window.localStorage.setItem("live2d-standbyOpacity", String(opacity || 0.5));
            if (!live2DCanvas) {
                live2DCanvas = document.getElementById("live2d");
            }
            live2DCanvas.style.opacity = String(standbyOpacity);
        }
        // 调整设置栏位置与 hover 区域逻辑
        function updateSettingsGroupPosition() {
            var canvas = document.getElementById("live2d") || null;
            var container = document.querySelector(".live2d-conrainer");
            var group = document.querySelector(settingsGroupSelector);
            if (!canvas || !container || !group)
                return;
            var canvasRect = canvas.getBoundingClientRect();
            var containerRect = container.getBoundingClientRect();
            // 将设置栏的左侧紧贴 canvas 的最右侧（相对于 container 的 left）
            var left = canvasRect.right - containerRect.left;
            group.style.left = "".concat(left, "px");
            // 将设置栏的顶部与 canvas 顶部对齐（保持在 canvas 高度范围内）
            group.style.top = "".concat(canvasRect.top - containerRect.top, "px");
        }
        function getSettingsGroupWidth() {
            var group = document.querySelector(settingsGroupSelector);
            return group ? group.getBoundingClientRect().width : 0;
        }
        // 覆盖默认的 mousemove 判定（使用 capture 阶段并阻止后续同目标的监听，避免原有老逻辑干扰）
        function combinedAreaMouseMove(event) {
            if (isForceStandby) {
                return;
            }
            if (!live2DCanvas) {
                live2DCanvas = document.getElementById("live2d");
                if (!live2DCanvas) {
                    isLive2DCanvasHovered.value = false;
                    isCharacterBeingHovered.value = false;
                    return;
                }
            }
            var canvasRect = live2DCanvas.getBoundingClientRect();
            var settingsWidth = getSettingsGroupWidth();
            var combinedRight = canvasRect.left + canvasRect.width + settingsWidth;
            var withinCombinedWidth = event.clientX >= canvasRect.left && event.clientX <= combinedRight;
            var withinCanvasHeight = event.clientY >= canvasRect.top && event.clientY <= canvasRect.bottom;
            var isWithinCombinedArea = withinCombinedWidth && withinCanvasHeight;
            isLive2DCanvasHovered.value = isWithinCombinedArea;
            if (!isWithinCombinedArea) {
                isCharacterBeingHovered.value = false;
                return;
            }
            // 如果在 canvas 宽度范围内，继续使用像素检测判断是否真正悬停到模型上
            if (event.clientX <= canvasRect.right) {
                // checkIsPositionOnLive2D 内部会根据 live2DCanvas 存在与否抛错或返回 false，所以保护调用
                try {
                    isCharacterBeingHovered.value = checkIsPositionOnLive2D(event.clientX, event.clientY);
                }
                catch (_a) {
                    isCharacterBeingHovered.value = false;
                }
            }
            else {
                // 在 settings 区域内（canvas 右侧的设置栏区域），不认为在角色上
                isCharacterBeingHovered.value = false;
            }
        }
        document.addEventListener("mousemove", combinedAreaMouseMove);
        // // 尝试在元素加载完成后再次定位设置栏（若资源异步加载，定时重试直到元素可用）
        // const _settingsPositionInterval = setInterval(() => {
        //   updateSettingsGroupPosition();
        //   if (
        //     document.getElementById("live2d") &&
        //     document.querySelector(settingsGroupSelector)
        //   ) {
        //     clearInterval(_settingsPositionInterval);
        //   }
        // }, 250);
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function startMoveLive2DCharacter(event) {
            event.preventDefault();
            if (!live2DComponent)
                return;
            var rect = live2DComponent.getBoundingClientRect();
            dragMoveX = event.clientX - rect.left;
            dragMoveY = event.clientY - rect.top;
        }
        // 按下移动后的移动事件处理
        function moveLive2DCharacter(event) {
            if (dragMoveX === undefined || dragMoveY === undefined || !live2DComponent) {
                return;
            }
            event.preventDefault();
            var x = event.clientX - dragMoveX;
            var y = event.clientY - dragMoveY;
            live2DComponent.style.left = "".concat(x, "px");
            live2DComponent.style.top = "".concat(y, "px");
        }
        function finishMoveLive2DCharacter(event) {
            if (dragMoveX === undefined || dragMoveY === undefined || !live2DComponent) {
                return;
            }
            window.localStorage.setItem("live2d-position-left", live2DComponent.style.left);
            window.localStorage.setItem("live2d-position-top", live2DComponent.style.top);
            dragMoveX = undefined;
            dragMoveY = undefined;
        }
        document.addEventListener("mousemove", moveLive2DCharacter);
        document.addEventListener("mouseup", finishMoveLive2DCharacter);
        // 发起持续一段时间的对话
        function setLive2DTalkContent(content, duration) {
            if (duration === void 0) { duration = 5; }
            if (isForceStandby) {
                return;
            }
            if (!content) {
                return;
            }
            if (isShowLive2DMessage.value && live2DMessageDisapearTimeout) {
                clearTimeout(live2DMessageDisapearTimeout);
            }
            live2DMessage.value = content;
            isShowLive2DMessage.value = true;
            live2DMessageDisapearTimeout = setTimeout(function () {
                isShowLive2DMessage.value = false;
            }, duration * 1000);
        }
        function setLive2DLongTalkContent(content) {
            if (isShowLive2DMessage.value && live2DMessageDisapearTimeout) {
                clearTimeout(live2DMessageDisapearTimeout);
            }
            live2DMessage.value = content;
            isShowLive2DMessage.value = true;
        }
        function cancelLive2DTalkContent() {
            isShowLive2DMessage.value = false;
        }
        function settingsItemHover(item) {
            if (chats === null || chats === void 0 ? void 0 : chats.hoverSettingsChat) {
                setLive2DLongTalkContent(chats.hoverSettingsChat[item]);
            }
        }
        function settingsItemOut() {
            if ((chats === null || chats === void 0 ? void 0 : chats.hoverSettingsChat) &&
                Object.values(chats.hoverSettingsChat).includes(live2DMessage.value))
                cancelLive2DTalkContent();
        }
        // 传入箭头函数，不绑定自己的 this，而是继承定义时所在作用域中的 this 和变量
        // 创建一个通用的函数来处理这些调用
        // 等效于 js 的：const midnightTalk = () => { setLive2DTalkContent(chats["timeChat"]["midnight"], 10); }, morningTalk = () => { setLive2DTalkContent(chats["timeChat"]["morning"], 10); }, afternoonTalk = () => { setLive2DTalkContent(chats["timeChat"]["afternoon"], 10); }, eveningTalk = () => { setLive2DTalkContent(chats["timeChat"]["evening"], 10); };
        // 缩减了大量类型与非空判断，否则以上 js 变 ts 会变成：
        // const midnightTalk = () => { if (chats && typeof chats["timeChat"] === "object") setLive2DTalkContent(chats["timeChat"]["midnight"], 10); },
        // morningTalk = () => { if (chats && typeof chats["timeChat"] === "object") setLive2DTalkContent(chats["timeChat"]["morning"], 10); },
        // afternoonTalk = () => { if (chats && typeof chats["timeChat"] === "object") setLive2DTalkContent(chats["timeChat"]["afternoon"], 10); },
        // eveningTalk = () => { if (chats && typeof chats["timeChat"] === "object") setLive2DTalkContent(chats["timeChat"]["evening"], 10); };
        var createTalkFunction = function (timeOfDay) {
            return function () {
                var _a, _b;
                var timeChat = (_a = chats === null || chats === void 0 ? void 0 : chats.timeChat) !== null && _a !== void 0 ? _a : {};
                setLive2DTalkContent((_b = timeChat[timeOfDay]) !== null && _b !== void 0 ? _b : "", 10);
            };
        };
        var midnightTalk = createTalkFunction("midnight");
        var morningTalk = createTalkFunction("morning");
        var afternoonTalk = createTalkFunction("afternoon");
        var eveningTalk = createTalkFunction("evening");
        tools.addOnTimeExecute(midnightTalk, "0");
        tools.addOnTimeExecute(morningTalk, "8:30");
        tools.addOnTimeExecute(afternoonTalk, "12");
        tools.addOnTimeExecute(eveningTalk, "19:30");
        tools.addGlobalTimerFunction(randomLive2DTalk, 10);
        window.setLive2DTalkContent = setLive2DTalkContent;
        window.setLive2DLongTalkContent = setLive2DLongTalkContent;
        window.cancelLive2DTalkContent = cancelLive2DTalkContent;
        window.Live2DForceStandby = Live2DForceStandby;
        window.stopForceStandby = stopForceStandby;
        window.checkIsPositionOnLive2D = checkIsPositionOnLive2D;
        window.getLive2dStandbyOpacity = getLive2dStandbyOpacity;
        window.setLive2dStandbyOpacity = setLive2dStandbyOpacity;
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (window.localStorage.getItem("live2d-standbyOpacity")) {
                            setLive2dStandbyOpacity(window.localStorage.getItem("live2d-standbyOpacity"));
                        }
                        else {
                            setLive2dStandbyOpacity(standbyOpacity);
                        }
                        return [4 /*yield*/, api.requestBase.get("/live2d/live2dURLList.json")];
                    case 1:
                        response = _a.sent();
                        // live2dJSONMap = await response.json();
                        live2dJSONList = response.data;
                        return [4 /*yield*/, loadLive2D()];
                    case 2:
                        _a.sent();
                        live2DComponent = document.querySelector(".live2d-conrainer");
                        if (live2DComponent &&
                            window.localStorage.getItem("live2d-position-left") &&
                            window.localStorage.getItem("live2d-position-top")) {
                            live2DComponent.style.left =
                                window.localStorage.getItem("live2d-position-left") || "0";
                            live2DComponent.style.top =
                                window.localStorage.getItem("live2d-position-top") || "0";
                        }
                        if (isFirstLoad) {
                            setLive2DTalkContent("似乎我们是第一次见面呢，请多多指教~");
                        }
                        else {
                            setLive2DTalkContent("欢迎回来~");
                        }
                        window.live2dStatus = "loaded";
                        if (window.localStorage.getItem("live2d-isForceStandby") === "true") {
                            Live2DForceStandby(false);
                        }
                        updateSettingsGroupPosition();
                        window.addEventListener("resize", updateSettingsGroupPosition);
                        return [2 /*return*/];
                }
            });
        }); });
        onBeforeUnmount(function () {
            window.live2dStatus = "unmounted";
            window.removeEventListener("resize", updateSettingsGroupPosition);
            document.removeEventListener("mousemove", combinedAreaMouseMove);
            document.removeEventListener("mousemove", moveLive2DCharacter);
            document.removeEventListener("mouseup", finishMoveLive2DCharacter);
            tools.removeOnTimeExecute(midnightTalk);
            tools.removeOnTimeExecute(morningTalk);
            tools.removeOnTimeExecute(afternoonTalk);
            tools.removeOnTimeExecute(eveningTalk);
            tools.removeGlobalTimerFunction(randomLive2DTalk);
            destroyLive2D(true);
        });
        // 随机对话
        function randomLive2DTalk() {
            if (isForceStandby) {
                return;
            }
            if (chats && Array.isArray(chats["randomChat"])) {
                var randomIndex = Math.round((chats["randomChat"].length - 1) * Math.random());
                setLive2DTalkContent(chats["randomChat"][randomIndex], 8);
            }
        }
        // 切换角色按钮逻辑
        function handleSwitchCharacterClick() {
            currentModelIndex = (currentModelIndex + 1) % ((live2dJSONList === null || live2dJSONList === void 0 ? void 0 : live2dJSONList.length) || 1);
            window.localStorage.setItem(modelIndexLocalStorageKey, String(currentModelIndex));
            switchLive2DCharacter();
            // setLive2DLongTalkContent(
            //   "只有一个角色，求任何人资助我更多好看的live2d角色！"
            // );
        }
        // 进入强制待机状态
        function Live2DForceStandby(isShowStandbyMessage) {
            if (isShowStandbyMessage === void 0) { isShowStandbyMessage = true; }
            if (isShowStandbyMessage) {
                if (chats && typeof chats["startForceStandby"] === "string") {
                    setLive2DTalkContent(chats["startForceStandby"]);
                }
            }
            isForceStandby = true;
            isCharacterBeingHovered.value = false;
            isLive2DCanvasHovered.value = false;
            window.live2dStatus = "forceStandby"; // 用于控制台或右键菜单判断是否处于强制待机状态
            window.localStorage.setItem("live2d-isForceStandby", "true");
        }
        // 设置透明度
        function setTransparent() {
            ///////////////////////////////////////////////////////////////////////
            // 透明度设置，迁移后根据当前情况进行修改
            ///////////////////////////////////////////////////////////////////////
            // document.querySelector("html")?.setAttribute("data-isShowConsole", "true");
            window.isConfigDrawerActive.value = true;
        }
        // 重置 live2d （位置，角色）
        function resetLive2D() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!live2DComponent)
                                return [2 /*return*/];
                            console.log("reset live2d");
                            isCharacterBeingHovered.value = false;
                            isLive2DCanvasHovered.value = false;
                            isShowLive2DMessage.value = false;
                            destroyLive2D();
                            live2DComponent.style.left =
                                "calc(100% - var(--live2d-width) - var(--live2d-sidebat-size) - 1.5rem)";
                            live2DComponent.style.top = "calc(100% - var(--live2d-height) / 1.65)";
                            window.localStorage.removeItem("live2d-position-left");
                            window.localStorage.removeItem("live2d-position-top");
                            window.localStorage.removeItem("live2d-isForceStandby");
                            window.localStorage.removeItem("live2d-standbyOpacity");
                            window.localStorage.removeItem("live2d-character");
                            setLive2dStandbyOpacity("0.5");
                            return [4 /*yield*/, loadLive2D()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function exitLive2d() {
            store.setLive2DShow(false);
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass([
                        'live2d-talk-box',
                        { 'live2d-talk-box-show': isShowLive2DMessage.value },
                    ])
                }, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(live2DMessage.value), 1)
                ], 2),
                _createElementVNode("canvas", {
                    id: "live2d",
                    class: _normalizeClass([
                        'Live2DComponentInnerClass',
                        {
                            Live2DNotLoad: !isLoaded.value,
                            Live2DCharacterHovered: isCharacterBeingHovered.value,
                        },
                    ])
                }, null, 2),
                _createElementVNode("div", {
                    class: _normalizeClass([
                        'live2d-settings-group',
                        { live2DSettingsGroupHover: isLive2DCanvasHovered.value },
                    ])
                }, [
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-chat",
                        onMouseenter: _cache[0] || (_cache[0] = function ($event) { return (settingsItemHover('chat')); }),
                        onMouseleave: settingsItemOut,
                        onClick: randomLive2DTalk
                    }, _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa-solid fa-comment live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-switch-character",
                        onMouseenter: _cache[1] || (_cache[1] = function ($event) { return (settingsItemHover('switchCharacter')); }),
                        onMouseleave: settingsItemOut,
                        onClick: handleSwitchCharacterClick
                    }, _cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fas fa-user-circle live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-transparent",
                        onMouseenter: _cache[2] || (_cache[2] = function ($event) { return (settingsItemHover('transparent')); }),
                        onMouseleave: settingsItemOut,
                        onClick: setTransparent
                    }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fa-brands fa-uncharted live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-move",
                        onMouseenter: _cache[3] || (_cache[3] = function ($event) { return (settingsItemHover('move')); }),
                        onMouseleave: settingsItemOut,
                        onMousedown: startMoveLive2DCharacter
                    }, _cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "fa-solid fa-arrows-up-down-left-right live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-lock",
                        onMouseenter: _cache[4] || (_cache[4] = function ($event) { return (settingsItemHover('forceStandby')); }),
                        onMouseleave: settingsItemOut,
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (Live2DForceStandby()); })
                    }, _cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fas fa-lock live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-reset",
                        onMouseenter: _cache[6] || (_cache[6] = function ($event) { return (settingsItemHover('reset')); }),
                        onMouseleave: settingsItemOut,
                        onClick: resetLive2D
                    }, _cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fa-solid fa-rotate-right live2d-settings-icon" }, null, -1)
                    ]), 32),
                    _createElementVNode("div", {
                        class: "live2d-settings-item live2d-settings-leave",
                        onMouseenter: _cache[7] || (_cache[7] = function ($event) { return (settingsItemHover('leave')); }),
                        onMouseleave: settingsItemOut,
                        onClick: exitLive2d
                    }, _cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fa-solid fa-right-from-bracket live2d-settings-icon" }, null, -1)
                    ]), 32)
                ], 2)
            ]));
        };
    }
});
